<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <v-card-title>
                        <span class="title">Danh sách chờ thanh toán</span>
                    </v-card-title>
                    <hpo-filter :headers="filter_headers" :viewName="viewName" v-on:applyFilter="applyFilter"
                        v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr :style="{'background-color': item.PaymentImage && item.PaymentImage != '' && item.PaymentImage != 'None' ? 'rgb(236 246 247)' : ''}">
                                <td>{{ item.Username }}</td>
                                <td>{{ item.SaleName }}</td>
                                <td>{{ item.PhoneNumber }}</td>
                                <td class="text-right">{{ item.BillCount }}</td>
                                <td class="text-right">{{ item.ReceiptCount }}</td>
                                <td class="text-right">{{ item.TotalAmount | currency }}</td>
                                <td><a :href="item.PaymentImage" target="_blank" rel="noopener noreferrer"><img class="image-product" :src="item.PaymentImage" alt/></a></td>
                                <td class="text-center">
                                    <v-btn small color="primary" @click="openPaymentDialog(item)">
                                        <v-icon small>payment</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>

        <!-- Payment Detail Dialog -->
        <payment-detail-dialog v-model="dialogPayment" :title="dialogTitle" :customer="currentCustomer" :bills="bills"
            :receipts="receipts" :is-history="false"
            @close="closePaymentDialog" @payment-success="onPaymentSuccess" />
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import Filtering from "@/components/Filtering";
import PaymentDetailDialog from "@/components/PaymentDetailDialog";
import createPermissionMixin from "@/mixins/permissionMixin";
import _ from "lodash";

export default {
    mixins: [createPermissionMixin('payment_pending')],
    components: {
        "hpo-filter": Filtering,
        "payment-detail-dialog": PaymentDetailDialog,
    },
    data() {
        return {
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "payment_pending_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogPayment: false,
            dialogTitle: '',
            currentCustomer: {},
            bills: [],
            receipts: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions)
                    ? filterConditions[this.viewName]
                    : [];
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.payment.all.data || [],
            total_rows: state => state.payment.all.total || 0,
            loading: state => state.payment.loading
        }),
        headers() {
            return [
                {
                    text: 'Mã khách',
                    value: 'Username',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: 'Nhân viên sale',
                    value: 'SaleName',
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: 'Số điện thoại',
                    value: 'PhoneNumber',
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: 'PX lô',
                    value: 'BillCount',
                    align: 'end',
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'PX TMĐT',
                    value: 'ReceiptCount',
                    align: 'end',
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Tổng tiền',
                    value: 'TotalAmount',
                    align: 'end',
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: 'Bill',
                    value: 'PaymentImage',
                    align: 'center',
                    filterable: false,
                    sortable: false
                },
                {
                    text: 'Thao tác',
                    value: '',
                    align: 'center',
                    width: '100px',
                    sortable: false,
                    filterable: false
                }
            ];
        },
        filter_headers() {
            let tmp = [...this.headers];
            tmp.push({
                    text: "Mã bill",
                    value: "BillCodes",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                });
            tmp.push({
                    text: "Mã phiếu xuất",
                    value: "ReceiptCodes",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                });
            return tmp;
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                search_term: this.search,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("payment/getList", param);
        },
        loadData() {
            this.filter_data();
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy;
            let sortDesc = this.pagination.sortDesc;
            this.pagination = _.cloneDeep(configs.PAGINATION);
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        openPaymentDialog(customer) {
            this.dialogTitle = 'Thanh toán cho khách hàng';
            this.currentCustomer = customer;

            this.$store.dispatch('payment/getDetail', customer.CustomerID).then(data => {
                this.currentCustomer = data.customer || {};
                this.bills = data.bills || [];
                this.receipts = data.receipts || [];
                this.dialogPayment = true;
            }).catch(error => {
                sendErrorNotice("Lỗi khi tải chi tiết: " + (error.message || error));
            });
        },
        closePaymentDialog() {
            this.dialogPayment = false;
            this.currentCustomer = {};
            this.bills = [];
            this.receipts = [];
            this.$store.commit('payment/CLEAR_CUSTOMER_DETAIL');
        },
        onPaymentSuccess() {
            this.closePaymentDialog();
            this.loadData();
        },
    },
    mounted() {
        this.loadData();
        this.$store.dispatch("productType/getList");
        this.$root.$on("REQUEST_REFRESH_DATA", this.loadData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.loadData);
    }
};
</script>
